import { BindingData, BindingList } from '@farris/devkit';

/**
 * æ æ°æ®çå¸®å©ç±»
 */
class ParentTreeNodeUtil {

  /**
   * éä¸­ç¬¬ä¸ä¸ªæ ¹èç¹
   */
  public selectFirstRootNode(bindingData: BindingData, hierarchyInfoKey: string): string {

    const treeNodesData = bindingData.list.toJSON();
    const firstRootNodeId = this.getFirstNodeId(treeNodesData, hierarchyInfoKey);
    this.selectedNode(bindingData, hierarchyInfoKey, firstRootNodeId);
    return firstRootNodeId;
  }
  public selectNodeByBindingList(bindingList: BindingList, hierarchyInfoKey: string, selectedNodeId: string): void {
    const treeNodesData = bindingList.toJSON();
    // å¦æè¦è®¾ç½®çèç¹ä¸å­å¨ï¼åè®¾ç½®ç¬¬1ä¸ªæ ¹èç¹
    const selectedNodeData = this.getNodeDataById(treeNodesData, selectedNodeId);
    let currentId = selectedNodeId;
    if (!selectedNodeData) {
      currentId = this.getFirstNodeId(treeNodesData, hierarchyInfoKey);
    }
    setTimeout(() => {
      bindingList.setCurrentId(currentId, true, true);
    }, 0);
  }
  /**
   * éä¸­èç¹
   */
  public selectedNode(bindingData: BindingData, hierarchyInfoKey: string, selectedNodeId: string): void {
    const treeNodesData = bindingData.list.toJSON();
    // å¦æè¦è®¾ç½®çèç¹ä¸å­å¨ï¼åè®¾ç½®ç¬¬1ä¸ªæ ¹èç¹
    const selectedNodeData = this.getNodeDataById(treeNodesData, selectedNodeId);
    let currentId = selectedNodeId;
    if (!selectedNodeData) {
      currentId = this.getFirstNodeId(treeNodesData, hierarchyInfoKey);
    }
    if (bindingData.rowSelectedEventSuspend === true) {
      return;
    }
    setTimeout(() => {
      bindingData.list.currentId = null;
      bindingData.list.setCurrentId(currentId, true, true);
    }, 0);
  }

  /**
   * æ£æ¥æ¯å¦æå­èç¹
   */
  public hasChildNodes(treeNodesData: any[], hierarchyInfoKey: string, fid: string): boolean {
    const fNodeData = this.getNodeDataById(treeNodesData, fid);
    // const fLayer = fNodeData[hierarchyInfoKey]['layer'];
    const fIsDetail = fNodeData[hierarchyInfoKey]['isDetail'];

    // éæç»èç¹ï¼è¿åtrue
    if (fIsDetail === false) {
      return true;
    }
    return false;

    // const childNodesData = this.getChildNodesData(treeNodesData, hierarchyInfoKey, fLayer, fid);
    // return childNodesData.length > 0;
  }

  /**
   * è·åæ ¹èç¹ï¼å¤ä¸ªæ ¹èç¹æ¶è·åç¬¬ä¸ä¸ªï¼
   * @return æ¾ä¸å°æ¶è¿ånull
   */
  private getFirstNodeId(treeNodesData: any[], hierarchyInfoKey: string): string {
    let rootData = treeNodesData.find((itemData: any) => {
      const layer = itemData[hierarchyInfoKey]['layer'];
      return layer === 1;
    });
    if (!rootData) {
      const rootLayer = this.getRootLayer(treeNodesData, hierarchyInfoKey);
      rootData = treeNodesData.find((itemData: any) => {
        const layer = itemData[hierarchyInfoKey]['layer'];
        return layer === rootLayer;
      });
    }
    return rootData ? rootData['id'] : '';
  }
  private getRootLayer(treeNodesData: any[], hierarchyInfoKey: string) {
    let layer = null;
    if (treeNodesData && Array.isArray(treeNodesData)) {
      const layers = treeNodesData.map(item => {
        const layer = item[hierarchyInfoKey]['layer'];
        return layer;
      });
      const minLayer = Math.min.apply(Math, layers);
      if (!isNaN(minLayer)) {
        layer = minLayer;
      }
    }
    return layer;
  }
  /**
   * è·åä¸ä¸ä¸ªèç¹ï¼å é¤åï¼
   */
  public getNextNodeId(treeNodesData: any[], hierarchyInfoKey: string, currentId: string): string {

    // å½åèç¹ä¿¡æ¯
    const currentNodeData = treeNodesData.find((itemData: any) => {
      return itemData['id'] === currentId;
    });
    const currentLayer = currentNodeData[hierarchyInfoKey]['layer'];

    // ç¶èç¹ä¿¡æ¯
    const fLayer = currentLayer - 1;
    const fParentElement = currentNodeData[hierarchyInfoKey]['parentElement'];

    // æ¥æ¾åå¼èç¹
    const siblingtreeNodesData = this.getChildNodesData(treeNodesData, hierarchyInfoKey, fLayer, fParentElement);

    // å¦ææ²¡æåå¼èç¹ï¼åä¸æ¥æ¾
    if (siblingtreeNodesData.length === 1) {
      const parentData = treeNodesData.find((itemData: any) => {
        return itemData['id'] === fParentElement;
      });

      // å­å¨ç¶èç¹ï¼åè®¾ç½®ç¶èç¹ï¼
      // ä¸å­å¨ç¶èç¹ï¼åè®¾ç½®ç¬¬ä¸ä¸ªæ ¹èç¹ã
      if (!parentData) {
        return this.getFirstNodeId(treeNodesData, hierarchyInfoKey);
      }
      return parentData['id'];
    } else {
      return this.getNextSiblingNodeId(siblingtreeNodesData, currentId);
    }
  }

  /**
   * è·åä¸ä¸ªåå¼èç¹çid
   */
  public getNextSiblingNodeId(siblingtreeNodesData: any[], currentId: string): string {
    if (siblingtreeNodesData.length <= 1) {
      return '';
    }

    const currentIndex = siblingtreeNodesData.findIndex((itemData: any) => {
      return itemData['id'] === currentId;
    });

    // æåä¸è¡ä¸ç§»ä¸è¡ï¼å¶ä»ä¸ç§»ä¸è¡
    let nextIndex = -1;
    if (currentIndex === siblingtreeNodesData.length - 1) {
      nextIndex = currentIndex - 1;
    } else {
      nextIndex = currentIndex + 1;
    }

    return siblingtreeNodesData[nextIndex]['id'];
  }

  /**
   * è·åä¸çº§èç¹çBindingObjectséå
   */
  public getChildNodesData(treeNodesData: any[], hierarchyInfoKey: string, fLayer: number, fParentElement: string): any[] {
    const childtreeNodesData = treeNodesData.filter((itemData) => {
      const layer = itemData[hierarchyInfoKey]['layer'];
      const parentElement = itemData[hierarchyInfoKey]['parentElement'];
      return (layer === fLayer + 1) && fParentElement == parentElement;
    });
    return childtreeNodesData;
  }

  /**
   * è·åidè·åèç¹æ°æ®
   */
  public getNodeDataById(treeNodesData: any[], id: string): any {
    const nodeData = treeNodesData.find((itemData: any) => {
      return itemData['id'] === id;
    });
    return nodeData ? nodeData : null;
  }
}

export { ParentTreeNodeUtil };
